import { queryOptions, useQuery } from '@tanstack/react-query';
import { type CryptoPrice, getCryptoPrices, getLoans } from '@/services/api/loans';
import { uniqueSorted } from '@/utils/array';

export const LOANS_QUERY_KEY = ['system', 'loans'] as const;
export const CRYPTO_PRICES_QUERY_KEY = ['crypto-info', 'prices'] as const;

// Stable module-level select — an inline closure would defeat select memoization
const selectSymbols = (data: CryptoPrice[]): string[] => uniqueSorted(data.map((price) => price.symbol));

export const loansQueryOptions = () =>
  queryOptions({
    queryKey: LOANS_QUERY_KEY,
    queryFn: getLoans,
  });

export const useLoans = () => useQuery(loansQueryOptions());

export const cryptoPriceSymbolsQueryOptions = () =>
  queryOptions({
    queryKey: CRYPTO_PRICES_QUERY_KEY,
    queryFn: getCryptoPrices,
    select: selectSymbols,
  });

/** Asset options for the add-asset dialog; fetches when the dialog mounts */
export const useCryptoPriceSymbols = () => useQuery(cryptoPriceSymbolsQueryOptions());
